module.exports = __webpack_public_path__ + "img/区域切除3.d4c77a99.svg";